import React from 'react'
import "../../Styles/ContactUs.css"

const Map = () => {
    return (
        <div>
            <section className='MapSection h-screen'>
                <div>         
                </div>
            </section>
        </div>
    )
}

export default Map